import React, { useEffect, useState } from "react";
// React router
import { Redirect, Route, Switch } from "react-router-dom";
// Componentes
import Menu from "./Menu";
import Header from "./header";

import GrupoTrabajoAdd from "./grupo_trabajo/grupo_trabajo_add";
import UsuarioAdd from "./usuario/usuario_add";
import FormNuevaMision from "./provincia/misiones/formularios/FormNuevaMision";

import Perfil from "./usuario/perfil";
import DireccionGeneral from "./direccion_general/direccion_general";

import Hermanas from "./usuario/Hermanas.jsx";
import Comunidades from "./comunidad/Comunidades";
import Provincias from "./provincia/Provincias";
import Laicos from "./usuario/Laicos.jsx";
import Misiones from "./provincia/misiones/Misiones";

import UsuarioDetalle from "./usuario/usuario_detalle";
import ProvinciaDetalle from "./provincia/provincia_detalle";
import ComunidadDetalle from "./comunidad/ComunidadDetalle";
import GruposTrabajoDetalle from "./grupo_trabajo/grupo_trabajo_detalle";
import MisionDetalle from "./provincia/misiones/MisionDetalle";
import GruposTrabajo from "./grupo_trabajo/GruposTrabajo";
import GruposDireccionGeneral from "./direccion_general/GruposTrabajoDireccionGeneral";

import GuardedRoute from "./generic/GuardRoute";
import NoExiste from "./no_existe";
import { InformesMenu } from "./informes/informes_menu";
import { Familia } from "./familia/familia";
import { Fet } from "./familia/fet";
import { Fundeo } from "./familia/fundeo";
import { Mta } from "./familia/mta";

// React Bootstrap
import { Container } from "react-bootstrap";
// Styled Components
import styled from "styled-components";
import { AddExternoMta } from "./familia/externos/addExternoMta";
import { AddExternoFet } from "./familia/externos/addExternoFet";
import { AddExternoFundeo } from "./familia/externos/addExternoFundeo";

import ConfigApp from "./ConfigApp"

import $ from "jquery";

const CustomContainer = styled(Container)`
  max-width: 1450px;
  display: block !important;
`;

const Root = ({ logout, perfil, ...props }) => {

    const [config, setConfig] = useState({ edicionHermanas: localStorage.getItem("edicionHermanas") });
    const [provinciaLogueado, setProvinciaLogueado] = useState({ null: null, null: null })

    useEffect(() => {
        //obtengo la configuración y la reobtengo cuando se setee
        obtenerConfig()
        obtenerUsuario()
        //('entre entre entre entre entre ')
    }, []);

    const obtenerConfig = () => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/accessleveltwo`,
            method: "GET",
            timeout: 0,
            xhrFields: {
                withCredentials: true,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        };

        $.ajax(settings)
            .done((response) => {
                setConfig(response);
                localStorage.setItem("edicionHermanas", response.edicionHermanas)
            })
            .fail((error) => {
                console.log('error 55')
            });
    };

    const obtenerUsuario = () => {
        //lo hago para obterner la provincia de donde es para luego filtrar en el nivel 9 por la gente que tiene su misma provincia
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/usuarios/${perfil.id}`,
            method: "GET",
            timeout: 0,
            xhrFields: {
                withCredentials: true,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        };
        $.ajax(settings)
            .done((response) => {
                setProvinciaLogueado(
                    {
                        id:
                            response.sister ? response.sister.destinations[0]?.provinceId
                                :
                                response.destinationLaicos[0]?.provinceId
                        , nombre:
                            response.sister ? response.sister.destinations[0]?.province?.name
                                :
                                response.destinationLaicos[0]?.province.name
                    })
            })
            .fail((error) => {
                console.log('error 56')
            });
    };
    return (
        <>
            {perfil.accessLevel >= 10 && localStorage.getItem("edicionHermanas") === 'true' && <Header mensaje={`WARNING: ACCESO DE EDICIÓN DE PERFIL DE HERMANA ACTIVO PARA TODAS LAS HERMANAS`}></Header>}
            <Menu perfil={perfil} config={config} logout={logout} />
            <CustomContainer className={"pt-4 mb-5"}>
                <Switch>
                    {/* Prueba para hacer los cargos TODO quitar */}
                    {/* <GuardedRoute {...props} exact path="/cargos" perfil={perfil} component={Cargos} condition={perfil.accessLevel >= 2} redirect={"/login"} /> */}
                    {/*modificio para que la ruta del perfil sea accesible únicamente si está habilitada la configuración 052022*/}

                    <GuardedRoute {...props} exact path="/perfil" perfil={perfil}
                        component={Perfil}
                        condition={(perfil.accessLevel >= 3 || (perfil.accessLevel === 2 && localStorage.getItem("edicionHermanas") === 'true'))}
                        redirect={"/login"} />

                    <GuardedRoute {...props} exact path="/direccionGeneral"
                        component={DireccionGeneral}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/direccionGeneral/gruposTrabajo"
                        component={GruposDireccionGeneral}
                        condition={perfil.accessLevel >= 10}

                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/direccionGeneral/gruposTrabajo/add"
                        component={GrupoTrabajoAdd}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/direccionGeneral/gruposTrabajo/:id_t"
                        component={GruposTrabajoDetalle}
                        condition={perfil.accessLevel >= 10}

                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/provincias"
                        component={Provincias}
                        condition={perfil.accessLevel >= 2}
                        userLevel={perfil.accessLevel}
                        provinciaLogueado={provinciaLogueado}
                        redirect={config.edicionHermanas === 'true' ? "/perfil" : "/hermanas"} />

                    <GuardedRoute {...props} exact path="/informes"
                        component={InformesMenu}
                        condition={perfil.accessLevel >= 8}
                        redirect={"/perfil"}
                        userLevel={perfil.accessLevel}
                        provinciaLogueado={provinciaLogueado}
                        token={perfil} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p"
                        component={ProvinciaDetalle}
                        condition={perfil.accessLevel >= 8}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/comunidades"
                        component={Comunidades}
                        condition={perfil.accessLevel >= 2}
                        redirect={"/perfil"}
                        userLevel={perfil.accessLevel} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/mision"
                        component={Misiones}
                        condition={perfil.accessLevel >= 2}
                        redirect={"/perfil"}
                        userLevel={perfil.accessLevel} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/mision/add"
                        component={FormNuevaMision}
                        condition={perfil.accessLevel >= 8}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/mision/:id_m"
                        component={MisionDetalle}
                        condition={perfil.accessLevel >= 2}
                        redirect={"/perfil"}
                        userLevel={perfil.accessLevel} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/comunidades/:id_c"
                        component={ComunidadDetalle}
                        condition={perfil.accessLevel >= 2}
                        redirect={"/perfil"}
                        userLevel={perfil.accessLevel} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/gruposTrabajo"
                        component={GruposTrabajo}
                        condition={perfil.accessLevel >= 8}
                        userLevel={perfil.accessLevel}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/gruposTrabajo/add"
                        component={GrupoTrabajoAdd}
                        condition={perfil.accessLevel >= 8}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/provincias/:id_p/gruposTrabajo/:id_t"
                        component={GruposTrabajoDetalle}
                        condition={perfil.accessLevel >= 8}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/hermanas"
                        component={Hermanas}
                        condition={perfil.accessLevel >= 2}
                        userLevel={perfil.accessLevel}
                        provinciaLogueado={provinciaLogueado}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/laicos"
                        component={Laicos}
                        condition={perfil.accessLevel >= 8}
                        userLevel={perfil.accessLevel}
                        provinciaLogueado={provinciaLogueado}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/hermanas/add"
                        component={UsuarioAdd}
                        condition={perfil.accessLevel >= 9}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/hermanas/:id"
                        perfil={perfil}
                        component={UsuarioDetalle}
                        condition={perfil.accessLevel >= 9}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/laicos/add"
                        component={UsuarioAdd}
                        condition={perfil.accessLevel >= 8}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path="/laicos/:id"
                        perfil={perfil}
                        component={UsuarioDetalle}
                        condition={perfil.accessLevel >= 8}
                        redirect={"/perfil"} />

                    <GuardedRoute {...props} exact path={"/familia"}
                        component={Familia}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/"} />

                    <GuardedRoute {...props} exact path={"/familia/fet"}
                        component={Fet}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/"} />

                    <GuardedRoute {...props} exact path={"/familia/fundeo"}
                        component={Fundeo}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/"} />

                    <GuardedRoute {...props} exact path={"/familia/mta"}
                        component={Mta}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/"} />

                    <GuardedRoute {...props} exact path={"/familia/mta/addexterno"}
                        component={AddExternoMta}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/"} />

                    <GuardedRoute {...props} exact path={"/familia/fet/addexterno"}
                        component={AddExternoFet}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/"} />

                    <GuardedRoute {...props} exact path={"/familia/fundeo/addexterno"}
                        component={AddExternoFundeo}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/"} />

                    <GuardedRoute {...props} exact path="/configuracion"
                        perfil={perfil}
                        component={ConfigApp}
                        condition={perfil.accessLevel >= 10}
                        redirect={"/configuracion"} />

                    <Route exact path="/">
                        <Redirect to="/provincias" />

                    </Route>
                    <Route exact path="/login">

                        <Redirect to={config.edicionHermanas === 'true' ? "/perfil" : "/hermanas"} />
                    </Route>
                    <Route path="/">
                        <NoExiste {...props} />
                    </Route>
                </Switch>
            </CustomContainer>
        </>
    );
};
export default Root;
